module.exports = __webpack_public_path__ + "static/click_heatmap_monthly-fa6483bb74f78c17c0ae030844837038.jpg";